import { createAction } from "redux-act";
import { IFooterReducerState } from 'modules/reducers/footer';

export const fetchFooterJSON = createAction( "Fetch Footer JSON" );
export const fetchFooterJSONSuccess = createAction<IFooterReducerState>( "Fetch Footer JSON Success" );
export const fetchFooterJSONFailed = createAction<any>( "Fetch Footer JSON Failed" );